
import { dbh_helper } from "Ressources/dbh_helper";
import { Slider } from "../../../Scripts/Controls/dbh_slider";
import { OrganigramHelper, OrganigramInfos } from "./organigram";

$(document).ready(function () {
    if (dbh_helper.getUrlArea() == "booklet") {
        if ($('#home-background').length > 0) {
            const homeSlider = new Slider();
            homeSlider.InitSlider($('#home-background'), 5, 2);
        }

        $(document).on('click touchend', '.content-tab', function (e) {
            e.stopPropagation();
            e.preventDefault();

            const $this = $(this);
            const tabName = $this.data('tab');

            if (tabName) {
                $('.content-tab').removeClass('active');
                $this.addClass('active');
                $('.content-content-tab').removeClass('active');
                $(`.content-content-tab[data-tab='${tabName}']`).addClass('active');
            }
        })

        if (dbh_helper.getUrlController() == "organigram") {
            const organigramHelper: OrganigramHelper = new OrganigramHelper(new OrganigramInfos(8, 16, []));

            //$.getJSON('../scripts/_stiftungOrganigram.json', function (jd) {
            //    if (jd) {
            //        const organigram = jd;
            //        organigramHelper.BuildOrganigramRecursive(organigram, $('#orga-stiftung'), true, 470);
            //    }
            //});

            //if ($('#orga-stiftung').length > 0) {
            //    $.getJSON('../scripts/_stiftung_organigram.json', function (jd) {
            //        if (jd) {
            //            const organigram = jd;
            //            organigramHelper.BuildOrganigramRecursive($('#orga-stiftung'), organigram);
            //        }
            //    });
            //}
            let organigram;
            if ($(".edit-organigram-container").length > 0) {
                $.getJSON('../scripts/_stiftung_organigram.json', function (jd) {
                    if (jd) {
                        organigram = jd;
                    }
                })
                    .fail(function () { alert('Beim Laden der Organigram ist ein Fehler aufgetreten! '); })
                    .always(function () {
                        organigramHelper.InitEditOrganigram($(".edit-organigram-container"), organigram);
                    });
            }
        }
        if (dbh_helper.getUrlController() == "teams") {
            let searchTimeout = null;

            $('#teams-search').on('keyup', function () {
                if (searchTimeout) {
                    clearTimeout(searchTimeout);
                }
                const searchTerm = $(this).val().toString().toLowerCase().trim();

                searchTimeout = setTimeout(function () {
                    const $teams = $('.teams-boxen .teams-box');

                    if (searchTerm.length === 0) {
                        $teams.removeClass('notInSearchResults');
                        return;
                    }
                    for (let i = 0; i < $teams.length; i++) {
                        const $curTeam = $($teams[i]);
                        if ($curTeam.find('h3').html().toLowerCase().indexOf(searchTerm) >= 0
                            || $curTeam.find('p').html().toLowerCase().indexOf(searchTerm) >= 0
                            || altTextMatchesSearch($curTeam, searchTerm)) {
                            $curTeam.removeClass('notInSearchResults');
                        } else {
                            $curTeam.addClass('notInSearchResults');
                        }
                    }
                }, 250);
            });
        }

        const altTextMatchesSearch = ($curTeam, searchTerm) => {
            const $images = $curTeam.find('.teams-member img');

            if ($images.length === 0) {
                return false;
            }

            for (let i = 0; i < $images.length; i++) {
                const $curImg = $($images[i]);
                if ($curImg.attr('title').toString().toLowerCase().indexOf(searchTerm) >= 0) {
                    return true;
                }
            }

            return false;
        }

    }
});

